import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import HelpTip from "@/components/HelpTip";

function statusOf(c) {
    const now = new Date().toISOString();
    if (!c.sale_active) return { label: "Paused", color: "#6b7280" };
    if (c.sale_starts_at && c.sale_starts_at > now) return { label: "Scheduled", color: "#f59e0b" };
    if (c.sale_ends_at && c.sale_ends_at < now) return { label: "Ended", color: "#9ca3af" };
    return { label: "Live", color: "#16a34a" };
}

export default function AdminSalesOverview() {
    const [cats, setCats] = useState([]);
    const [productCounts, setCounts] = useState({});

    useEffect(() => {
        (async () => {
            const r = await api.get("/categories?include_hidden=true");
            const sales = r.data.filter(c => c.is_sale);
            setCats(sales);
            const counts = {};
            for (const c of sales) {
                try { const pc = await api.get(`/admin/categories/${c.id}/product-count`); counts[c.id] = pc.data.product_count; } catch {}
            }
            setCounts(counts);
        })();
    }, []);

    return (
        <div data-testid="admin-sales-overview">
            <div className="flex items-center gap-2 mb-6">
                <h1 className="font-display text-4xl tracking-tighter">Sales Overview</h1>
                <HelpTip>Every category with "Sale Category" turned on appears here. Edit a sale in the Categories tab.</HelpTip>
            </div>
            {cats.length === 0 ? (
                <div className="bg-white border-2 border-black p-10 text-center font-mono text-sm">
                    No sale categories yet. Go to <b>Categories</b> → edit a category → turn on <b>"This is a Sale Category"</b>.
                </div>
            ) : (
                <div className="space-y-3">
                    {cats.map(c => {
                        const s = statusOf(c);
                        return (
                            <div key={c.id} className="bg-white border-2 border-black p-5 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
                                <div>
                                    <div className="font-display text-2xl">{c.name}</div>
                                    <div className="font-mono text-xs text-neutral-500">slug: {c.slug}</div>
                                    <div className="font-mono text-xs mt-1">
                                        Discount: {c.sale_discount_type === "flat" ? `₹${c.sale_discount_value}` : `${c.sale_discount_value}%`}
                                        {c.sale_starts_at && ` · from ${new Date(c.sale_starts_at).toLocaleString()}`}
                                        {c.sale_ends_at && ` · until ${new Date(c.sale_ends_at).toLocaleString()}`}
                                    </div>
                                </div>
                                <div className="flex items-center gap-4">
                                    <div className="font-mono text-xs">{productCounts[c.id] ?? "…"} products</div>
                                    <div className="px-3 py-1 font-mono text-[10px] uppercase text-white" style={{ background: s.color }}>{s.label}</div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
}
